import { render, staticRenderFns } from "./NotesIcon.vue?vue&type=template&id=72dc57f8&scoped=true&"
import script from "./NotesIcon.vue?vue&type=script&lang=js&"
export * from "./NotesIcon.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "72dc57f8",
  null
  ,true
)

export default component.exports